import React, { PureComponent } from "react";
import { Modal, Button } from "react-bootstrap";
import { getRequest } from "../../api/ApiService";
import { bootstrapUtils } from "react-bootstrap/lib/utils";
import { postRequest } from "../../api/ApiService";
import FontAwesome from "react-fontawesome";

bootstrapUtils.addStyle(Button, "light-blue");

const STUDENT_ROLE = 1;
const IAS_ROLE = 2;

class IASCourseModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      course_name: props.currentCourse ? props.currentCourse.name : "",
      course_id: props.currentCourse ? props.currentCourse.id : 0,
      course_members: [],
      possible_assistents: [],
      users: [],
      course_member_id: 0
    };
  }

  componentWillMount() {
    this.fetchCourseMembers();
    this.fetchUsers();
  }

  componentWillReceiveProps(nextProps) {
    const course_id = nextProps.currentCourse ? nextProps.currentCourse.id : 0;
    const course_name = nextProps.currentCourse
      ? nextProps.currentCourse.name
      : "";

    if (this.state.course_id !== course_id) {
      this.setState(
        {
          course_name,
          course_id
        },
        () => {
          this.fetchCourseMembers();
        }
      );
    }
  }

  fetchCourseMembers = () => {
    const { course_id } = this.state;

    if (course_id > 0) {
      getRequest(
        `${process.env.REACT_APP_API_URL}courses/${course_id}/members/`
      )
        .then(res => {
          this.setState({
            course_members: res.body.filter(i => i.type === IAS_ROLE),
            possible_assistents: res.body.filter(i => i.type === STUDENT_ROLE)
          });
        })
        .catch(err => {});
    } else {
      this.setState({
        course_members: []
      });
    }
  };

  fetchUsers = () => {
    getRequest(`${process.env.REACT_APP_API_URL}users/`)
      .then(res => {
        this.setState({
          users: res.body
        });
      })
      .catch(err => {});
  };

  getUserName = user_id => {
    const { users } = this.state;
    const user = users.find(i => i.id === user_id);

    return user ? user.username : "";
  };

  changeSelect = e => {
    const select = e.target;

    this.setState({
      [select.name]: select.value
    });
  };

  submit = () => {
    const { course_member_id, course_id } = this.state;

    if (course_member_id) {
      postRequest(
        `${process.env.REACT_APP_API_URL}courses/${course_id}/add_assistant/`
      )
        .send({
          course_member: course_member_id
        })
        .then(res => {
          this.fetchCourseMembers();
          this.props.fetchData();
          this.setState({
            course_member_id: 0
          });
        })
        .catch(err => {});
    }
  };

  remove = (e, course_member) => {
    e.preventDefault();

    const { course_id } = this.state;

    if (course_member > 0) {
      postRequest(
        `${process.env.REACT_APP_API_URL}courses/${course_id}/remove_assistant/`
      )
        .send({
          course_member
        })
        .then(res => {
          this.fetchCourseMembers();
          this.props.fetchData();
        })
        .catch(err => {});
    }
  };

  render() {
    const { show, onHide } = this.props;
    const {
      course_members,
      possible_assistents,
      course_member_id
    } = this.state;

    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header>
          <h4 className="modal-title title-light-blue">IA List Popup</h4>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive">
            <table className="table">
              <tbody>
                {course_members.map((course_member, index) => (
                  <tr key={index} className="border-none instructor-modal-row">
                    <td>
                      {index + 1}. {this.getUserName(course_member.user)}
                      <a
                        href="/#"
                        onClick={e => this.remove(e, course_member.id)}
                        className="no-outline"
                      >
                        <FontAwesome
                          className="instructor-close"
                          name="close"
                        />
                      </a>
                    </td>
                  </tr>
                ))}
                <tr className="border-none instructor-modal-row">
                  <td>
                    <select
                      name="course_member_id"
                      value={course_member_id}
                      onChange={this.changeSelect}
                    >
                      <option value="0">Select user</option>
                      {possible_assistents.map((possible_assistent, index) => (
                        <option key={index} value={possible_assistent.id}>
                          {this.getUserName(possible_assistent.user)}
                        </option>
                      ))}
                    </select>
                    <Button
                      bsStyle="light-blue"
                      onClick={this.submit}
                      block={true}
                    >
                      Add
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default IASCourseModal;



// WEBPACK FOOTER //
// ./src/instructor/components/ias-course-modal.js